import { getLineasDeVehiculosSinPaginar } from 'api/recaudacion/lineasVehiculares';
import { getVersionesVehiculares } from 'api/catalogos/versionVehicular';
import { toMoment } from 'utils/normalizers';

export const propsRpvConsulta = [
  ['doConsRpv_NIV_RPV', 'numero_de_identificacion_vehicular'],
  ['doConsRpv_Placa', 'numero_de_placa_vigente'],
  ['doConsRpv_NRPV', 'registro_publico_vehicular'],
];

export const propsRpvGeneral = [
  ['doConsRpv_Marca_padron', 'marca', 'Marca'],
  ['doConsRpv_Submarca_padron', 'linea', 'LineaVehicular'],
  ['doConsRpv_Modelo', 'modelo'],
  ['doConsRpv_Version', 'version_vehicular', 'VersionVehicular'],
  ['doConsRpv_Color', 'color_del_vehiculo', 'CatalogoDeColorVehicular'],
  ['doConsRpv_Tipo_vehiculo_padron', 'tipo_de_vehiculo', 'TipoDeVehiculo'],
  ['doConsRpv_Tipo_uso_padron', 'uso_del_vehiculo', 'UsoDeLaMotocicleta'],
  ...propsRpvConsulta,
  ['doConsRpv_Motor', 'numero_de_motor'],
  ['doConsRpv_Observaciones', 'observaciones'],
  ['doConsRpv_Estatus_registro', 'estatus_registro_repuve'],
];

export const propsRpvProcedencia = [
  ['doConsRpv_procedencia', 'procedencia_vehiculo', 'ProcedenciaDeVehiculo'],
  ['doConsRpv_Aduana', 'aduana'],
  ['doConsRpv_Nombre_aduana', 'nombre_de_la_aduana'],
  ['doConsRpv_Patente', 'numero_de_patente'],
  ['doConsRpv_Pedimento', 'numero_de_pedimento'],
  ['doConsRpv_Fecha_pedimento', 'fecha_de_pedimento'],
  ['doConsRpv_Clave_importador', 'clave_del_importador'],
];

export const propsRpv = [...propsRpvGeneral, ...propsRpvProcedencia];

export const rpvPropsToLocal = (fields, valuesRepuve, find) => {
  const output = {};
  fields.forEach(([rpvKey, localKey, dataSrc]) => {
    output[localKey] = dataSrc && find ? find(dataSrc, rpvKey) : valuesRepuve[rpvKey];
  });
  return output;
};

export const valuesRepuveToLocales = async (valuesRepuve, dataSources = {}) => {
  const find = (dataSrc, valKey) => dataSources[dataSrc]
    ?.find((e) => e.nombre === valuesRepuve[valKey] || e.descripcion === valuesRepuve[valKey])?.id;
  let output = {};
  output.marca = find('Marca', 'doConsRpv_Marca_padron', 'nombre');
  if (output.marca) {
    // eslint-disable-next-line no-param-reassign
    dataSources.LineaVehicular = await getLineasDeVehiculosSinPaginar({
      marca: output.marca,
    });
    output.linea = find('LineaVehicular', 'doConsRpv_Submarca_padron', 'nombre');
    if (output.linea) {
      const versiones = await getVersionesVehiculares({
        linea_vehicular: output.linea,
        descripcion: valuesRepuve.doConsRpv_Version,
      });
      if (versiones.results.length === 1) {
        // eslint-disable-next-line no-param-reassign
        dataSources.VersionVehicular = versiones.results;
        output.version_vehicular = versiones.results[0].id;
      }
    }
  }
  output = {
    ...output,
    ...rpvPropsToLocal(propsRpvGeneral.filter((e, i) => ![0, 1, 3]
      .includes(i)), valuesRepuve, find),
    ...rpvPropsToLocal(propsRpvProcedencia, valuesRepuve, find),
    fecha_de_pedimento: toMoment(valuesRepuve.doConsRpv_Fecha_pedimento, ['DD/MM/YYYY']),
  };
  // TODO: dudas
  // se guardaran los valores no mostrados?
  // se mostraran de alguna forma todos los datos? aun es posible que version no se llene
  // en la modificacion como funcionara la comparacion de datos locales contra webservice
  // sera necesario meter alguna validacion extra para definir cuando se hace la consulta,
  //    actualmente se hace siempre que es alta
  return output;
};
